import { Row, Col, Modal, Button, Form, Spin } from "antd";
import WeaFormItem from "../../wea-form-item";
import isEmpty from "lodash/isEmpty";
import uniq from "lodash/uniq";
import isEqual from "lodash/isEqual";
import findIndex from "lodash/findIndex";
import xor from "lodash/xor";

import WeaInputSearch from "../../wea-input-search";
import WeaSearchBrowserBox from "../wea-search-browser-box";
import WeaAssociativeSearchMult from "../wea-associative-search-mult";
import Operation from "../../wea-transfer/operation";
import WeaBrowserMutiRight from "../wea-browser-muti-right";
import WeaTools from "../../wea-tools";
import WeaBrowserMutiLeft from "../../wea-browser/components/WeaTableLeft";
import WeaNewScroll from "../../wea-new-scroll";
import uniqBy from "lodash/uniqBy";
import isString from "lodash/isString";
import WeaLocaleProvider from "../../wea-locale-provider";

import { callApi } from "../../wea-tools/callApi";
const getLabel = WeaLocaleProvider.getLabel;

const initialState = {
  showSearchAd: false,
  count: 0,
  visible: false,
  currentPage: 1,
  inputValue: "",
  searchPara: {},
  checkStrictly: true,
  browserConditions: [],
  leftListSelectedKeys: [],
  leftListSelectedData: [],
  loadedModules: [],
  expandModules: [],
  selectedValue: null,
  displayType: "",
  loading: true
};

class Main extends React.PureComponent {
  static Operation = Operation;
  static defaultProps = {
    mult: true,
    needCallDest: true,
    checkStrictly: true
  };
  constructor(props) {
    super(props);
    const { dataUrl } = this.props;
    this.state = {
      visible: null,
      initialShowSearchAd: false,
      showSearchAd: false,
      rightCheckedKeys: [], //右侧选择的keys
      rightDatas: [], // 右侧展示的数据
      leftListSelectedKeys: [], // 左侧table选择的keys
      leftListSelectedData: [], // 左侧table选择的数据
      selectedData: {}, // 搜索按钮选中的数据
      searchKeys: [], // 搜索按钮选择的keys
      listDatas: [],
      currentPage: 1,
      pageSize: props.pageSize || 20,
      count: 0,
      url: dataUrl,
      inputValue: "",
      searchPara: {},
      dataKey: "",
      noPgTableData: [],
      inputId: "",
      inputName: "",
      inputTop: [],
      inputBottom: [],
      browserConditions: [],
      displayType: "list", // list/tree
      contentType: 1, // 数据展示的类别
      quickSearch: "",
      defaultExpandedKeys: [],
      hiddenIds: "",
      selectedValue: null,
      loading: true,
      dropmenuDatas: [],
      loadedModules: [],
      expandModules: []
    };
  }
  componentDidMount() {
    // 默认显示数据
    if (!isEmpty(this.props.replaceDatas)) {
      this.replaceSearchValues(this.props.replaceDatas);
    }
    if (!isEmpty(this.props.valueObj)) {
      this.replaceSearchValues(this.props.valueObj);
    }
    this.props.initFunc && this.props.initFunc(this);
  }
  componentWillReceiveProps(nextProps) {
    if ("value" in nextProps && isEmpty(nextProps.value)) {
      this.setState({ searchKeys: [], selectedData: {} });
      this.refs.associativeSearch && this.refs.associativeSearch.clear();
    }
    if (
      "replaceDatas" in nextProps &&
      !isEqual(this.props.replaceDatas, nextProps.replaceDatas) &&
      !nextProps.replaceNotCtrl
    ) {
      this.replaceSearchValues(nextProps.replaceDatas || []);
      if (isEmpty(nextProps.replaceDatas)) {
        this.refs.associativeSearch && this.refs.associativeSearch.clear();
      }
    }
  }
  setLoading(bool) {
    this.setState({ loading: bool });
  }
  closeModal() {
    this.setState({ visible: false });
  }
  openModal() {
    this.onCustomClick();
  }

  onSearchChange(v) {
    // const quickSearch = this.state.quickSearch || 'name';
    // const { setFieldsValue } = this.props.form;
    // let params = this.getFields();
    // params[quickSearch] = v;
    // if (this.state.selectedValue) params['date2during'] = this.state.selectedValue;
    // let url = this.getUrl(true);
    // this.getData(url, 1, true, params); // 搜索获取数据
    // setFieldsValue(params); // 高级搜索数据联动
    // this.setState({
    //   url,
    //   inputValue: v,
    //   showSearchAd: false,
    //   searchPara: params,
    // });
    // this.refs.weaSrcoll && this.refs.weaSrcoll.scrollerToTop();
  }
  goSearch = e => {
    // const { tabs } = this.props;
    // const quickSearch = this.state.quickSearch || 'name';
    // e.preventDefault();
    // let params = this.getFields();
    // let url = this.getUrl(true);
    // this.getData(url, 1, true, params); // 搜索获取数据
    // this.setState({
    //   url,
    //   searchPara: params,
    //   showSearchAd: false,
    //   inputValue: params[quickSearch] || '',
    // });
    // if (params['date2during']) {
    //   this.setState({ selectedValue: params['date2during'] });
    // }
    // this.refs.weaSrcoll && this.refs.weaSrcoll.scrollerToTop();
  };
  showModal() {
    this.setState({ visible: true });
    this.props.onOpen && this.props.onOpen();
  }

  onCustomClick = e => {
    e && e.preventDefault();
    if (this.props.onBeforeFocusCheck) {
      let cb = this.onCustomClickInner.bind(this);
      this.props.onBeforeFocusCheck(cb);
    } else {
      this.onCustomClickInner(e);
    }
  };
  onCustomClickInner = e => {
    const { memorise } = this.props;
    if (memorise) {
      const { searchKeys, selectedData } = this.state;
      this.onBrowerClick(searchKeys, selectedData);
    } else {
      this.onBrowerClick();
    }
  };
  onBrowerClick = (keys, selectedObj) => {
    this.setState({ inputValue: "" }, () => {
      let initData = [];
      if (this.props.isEcCom) {
        for (const key in window.ecCom) {
          if (window.ecCom.hasOwnProperty(key)) {
            const element = window.ecCom[key];
            initData.push({
              id: key,
              idspan: key,
              title: key,
              titlespan: key,
              obj: element
            });
          }
        }
      } else {
        let comType = "";
        if (typeof this.props.comType == "string") {
          comType = this.props.comType;
        }
        if (typeof this.props.comType == "object") {
          comType = this.props.comType.join(",");
        }
        let params = {
          comtype: comType
        };
        callApi(
          "/api/system/componentmanage/queryComponentByComtype",
          "GET",
          params
        ).then(data => {
          if (data.status) {
            data.datas.forEach(element => {
              initData.push({
                id: element.id,
                idspan: element.id,
                name: element.name,
                namespan: element.name,
                title: element.title,
                titlespan: element.title,
                obj: element,
                isDevModule: true,
                comtype: element.comType || ""
              });
            });
          }
          this.setState({
            loading: false,
            listDatas: initData
          });
        });
        // window.devModuleConfig.forEach(element => {
        //   initData.push({
        //     id: element.id,
        //     idspan: element.id,
        //     name: element.name,
        //     namespan: element.name,
        //     title: element.title,
        //     titlespan: element.title,
        //     obj: element,
        //     isDevModule: true,
        //     comType: element.comType || '',
        //   })
        // });
        // if (this.props.comType) {
        //   initData = initData.filter((e) => e.comType === this.props.comType)
        // }
      }

      this.setState({
        inputId: "id",
        inputName: "name",
        inputTop: ["title"],
        inputBottom: ["name"]
      });
    });
    this.showModal();
  };
  reload() {
    this.onBrowerClick();
  }
  get() {
    const { rightDatas, inputId } = this.state;
    let values = [];
    !isEmpty(rightDatas) &&
      rightDatas.forEach(d => {
        values.push(d[inputId] || d.id);
      });
    return {
      id: values,
      datas: rightDatas
    };
  }
  handleOk() {
    const { rightDatas, inputId, inputName, contentType } = this.state;
    const { maxLength } = this.props;
    let values = [];
    let selectedData = {};
    if (!isEmpty(rightDatas)) {
      if (maxLength && maxLength < this.count(rightDatas, true)) {
        window.alert(`所选的数量不能超过${maxLength}!`);
        return;
      }
      rightDatas.forEach(item => {
        item.id = item[inputId] || item.id;
        item.name = item[inputName + "span"] || item[inputName];
        selectedData[item.id] = item;
        values.push(item.id);
      });
    }
    values = uniq(values);
    this.setState(
      {
        selectedData: selectedData,
        visible: false,
        searchKeys: values
      },
      () => {
        this.throwCurrentState(
          values.join(","),
          this.formatThrowDatas(rightDatas)
        );
        this.props.onClose && this.props.onClose();
        this.setState(initialState); //初始化浏览框
        this.refs.browserRight && this.refs.browserRight.reset();
      }
    );
  }
  handleCancel() {
    this.setState(initialState); //初始化浏览框
    this.refs.browserRight && this.refs.browserRight.reset();
    this.props.onCancel && this.props.onCancel();
    this.props.onClose && this.props.onClose();
  }
  handleClear() {
    this.setState({
      visible: false,
      rightDatas: [],
      rightCheckedKeys: [],
      leftListSelectedKeys: [],
      leftListSelectedData: [],
      selectedData: {},
      searchKeys: []
    });
    this.setState(initialState); //初始化浏览框
    this.throwCurrentState("", []);
    this.refs.browserRight && this.refs.browserRight.reset();
    this.props.onClose && this.props.onClose();
    this.refs.associativeSearch && this.refs.associativeSearch.clear();
  }
  set(datas) {
    this.replaceSearchValues(datas);
  }
  replaceSearchValues(datas = []) {
    let searchKeys = [],
      selectedData = {},
      rd = [];
    datas.forEach(item => {
      if (item) {
        searchKeys.push(item.id);
        selectedData[item.id] = item;
        rd.push(item);
      }
    });
    this.setState({
      searchKeys: searchKeys,
      selectedData: selectedData,
      rightDatas: rd
    });
    let ids = uniq(searchKeys).join(",");
    this.setState({ hiddenIds: ids });
    // this.throwCurrentState(searchKeys.join(','), datas);
  }
  formatThrowDatas(datas) {
    const { inputId, inputName } = this.state;
    if (!isEmpty(datas)) {
      datas.forEach(d => {
        d.id = d[inputId] || d.id || "";
        d.name = d[inputName + "span"] || d[inputName] || d.name || "";
      });
    }
    return datas;
  }
  onBrowerChangeHandler(values, datas) {
    this.setState({ searchKeys: values, selectedData: datas });
    const throwDatas = [];
    if (!isEmpty(values)) {
      values.forEach(v => {
        throwDatas.push(datas[v]);
      });
    }
    this.throwCurrentState(values.join(","), this.formatThrowDatas(throwDatas));
  }
  onBrowerChange(values, datas, needOnchange = true) {
    const { destUrl, needCallDest } = this.props;
    let rd = [];
    values.forEach(v => rd.push(datas[v]));
    this.setState({ searchKeys: values, selectedData: datas, rightDatas: rd });
    if (needOnchange)
      this.throwCurrentState(values.join(","), this.formatThrowDatas(datas));
    return;
  }
  onRightDoubleClick(key) {
    const { rightDatas, inputId } = this.state;
    const newRightDatas = rightDatas.filter(
      item => (item[inputId] || item.id) !== key
    );
    this.onCountChange(newRightDatas);
    this.setState({ rightDatas: newRightDatas, rightCheckedKeys: [] });
  }
  onleftDoubleClick(data) {
    const { rightDatas } = this.state;
    let temp = [{ ...data[0] }];
    temp[0].titlespan = temp[0].title;
    temp[0].namespan = temp[0].name;
    this.onCountChange(rightDatas.concat(temp));
    this.setState({
      rightDatas: rightDatas.concat(temp),
      rightCheckedKeys: [],
      leftListSelectedData: [],
      leftListSelectedKeys: []
    });
  }
  onCountChange(rightData) {
    const { count } = this.props;
    let result = this.count(rightData) || "";
    this.props.count && this.props.count(result);
  }
  moveTo = direction => {
    const { rightDatas, rightCheckedKeys, listDatas, inputId } = this.state;
    const { destUrl } = this.props;
    let rds = [];
    if (direction === "right") {
      const { leftListSelectedData } = this.state;
      let datas = [];
      leftListSelectedData.map(d => {
        let temp = { ...d };
        temp.titlespan = temp.title;
        temp.namespan = temp.name;
        datas.push(temp);
        return d;
      });
      rds = rightDatas.concat(datas);
      this.onCountChange(rds);
      this.setState({
        rightDatas: rds,
        rightCheckedKeys: [],
        leftListSelectedData: [],
        leftListSelectedKeys: []
      });
    }
    if (direction === "left") {
      rds = rightDatas.filter(
        item =>
          !rightCheckedKeys.some(checkedKey => item[inputId] === checkedKey)
      );
      this.setState({ rightDatas: rds, rightCheckedKeys: [] });
      this.onCountChange(rds);
    }

    if (direction === "allToLeft") {
      this.setState({ rightDatas: [], rightCheckedKeys: [] });
      this.onCountChange(rds);
    }

    // if (direction === 'allToRight') {
    //   if (this.leftListAllActive()) {
    //     let datas = listDatas.filter((d) => !d.isDevModule);
    //     datas = datas.map((d) => { d.titlespan = d.title; return d; });
    //     rds = rightDatas.concat(datas)
    //     this.setState({
    //       rightDatas: rds,
    //       rightCheckedKeys: [],
    //       leftListSelectedData: [],
    //       leftListSelectedKeys: [],
    //     })
    //   }
    //   this.onCountChange(rds);
    // }
  };

  moveToLeft = () => this.moveTo("left");
  moveToRight = () => this.moveTo("right");
  moveAllToLeft = () => this.moveTo("allToLeft");
  moveAllToRight = () => this.moveTo("allToRight");

  count(rightDatas = [], rNum = false) {
    const { inputId } = this.state;
    let count = 0;
    let ids = [];
    rightDatas.forEach(item => {
      ids.push(item[inputId]);
    });
    count += uniq(ids).length;
    if (rNum) return count;
    return count > 0 ? `(${count})` : "";
  }
  leftListAllActive() {
    const { rightDatas, listDatas, inputId } = this.state;
    let bool = true;
    if (isEmpty(listDatas)) bool = false;
    if (!isEmpty(listDatas) && !isEmpty(rightDatas)) {
      bool =
        listDatas.filter(l => !rightDatas.some(r => l[inputId] === r[inputId]))
          .length !== 0;
    }
    return bool;
  }
  doChangeEvent = v => {
    // const { setFieldsValue } = this.props.form;
    // let url = this.getUrl();
    // let params = this.getFields();
    // params.date2during = v;
    // this.getData(url, 1, true, params);
    // this.setState({ selectedValue: v });
    // setFieldsValue({ date2during: v });
  };
  reset() {
    this.setState({ inputValue: "" });
  }
  focus() {
    this.refs.associativeSearch.focus();
  }
  render() {
    const {
      bottomLeft,
      buttons,
      icon,
      iconBgcolor,
      title,
      fieldName,
      contentHeight,
      modalStyle
    } = this.props;
    const { type, customized } = this.props;
    const { loading, visible, listDatas, inputValue } = this.state;
    let {
      displayType,
      rightDatas,
      rightCheckedKeys,
      leftListSelectedKeys,
      selectedData,
      searchKeys
    } = this.state;
    const {
      inputId,
      inputName,
      inputTop,
      inputBottom,
      contentType,
      hiddenIds,
      expandModules
    } = this.state;
    searchKeys = uniq(searchKeys || []);
    let titleEle = (
      <Row>
        <Col span="22" style={{ paddingLeft: 20, lineHeight: "48px" }}>
          <div className="wea-hr-muti-input-title">
            {iconBgcolor ? (
              <div
                className="wea-workflow-radio-icon-circle"
                style={{ background: iconBgcolor ? iconBgcolor : "" }}
              >
                <i className={icon} />
              </div>
            ) : (
              <span style={{ verticalAlign: "middle", marginRight: 10 }}>
                <i className={icon} />
              </span>
            )}
            <span style={{ verticalAlign: "middle" }}>{title}</span>
          </div>
        </Col>
      </Row>
    );
    let inputArr = (
      <WeaAssociativeSearchMult
        {...this.props}
        ref="associativeSearch"
        inputName={inputName}
        inputId={inputId}
        style={this.props.inputStyle}
        datas={selectedData}
        selectedValues={searchKeys}
        type={type}
        clickCallback={this.onBrowerClick}
        onChange={this.onBrowerChangeHandler.bind(this)}
      />
    );
    let footerTemp = [];
    footerTemp.push(
      <Button
        key="submit"
        type="primary"
        onClick={this.handleOk.bind(this)}
        disabled={this.count(rightDatas, true) == 0}
      >
        {getLabel(385565, "确 定")}
        {this.count(rightDatas)}
      </Button>
    );
    if (
      !this.props.browserModalProps ||
      !this.props.browserModalProps.hideClear
    )
      footerTemp.push(
        <Button key="clear" type="ghost" onClick={this.handleClear.bind(this)}>
          {getLabel(385566, "清 除")}
        </Button>
      );
    footerTemp.push(
      <Button key="back" type="ghost" onClick={this.handleCancel.bind(this)}>
        {getLabel(385567, "取 消")}
      </Button>
    );

    const footer = buttons || footerTemp;
    if (bottomLeft)
      footer.unshift(
        <div
          className="ext-link"
          style={{ float: "left", cursor: "pointer", paddingLeft: 20 }}
        >
          {isString(bottomLeft) ? (
            <span dangerouslySetInnerHTML={{ __html: bottomLeft }} />
          ) : (
            <span>{bottomLeft}</span>
          )}
        </div>
      );
    const leftAllActive = displayType === "list" && this.leftListAllActive();
    let initHeight = contentHeight;
    if (window.setLayoutWindow) {
      let maxH = $(window.setLayoutWindow.document.body).height() - 220;
      if (window.setDialogFullWindow || initHeight > maxH) {
        if (isEmpty(this.props.tabs)) {
          maxH += 50;
        }
        initHeight = maxH;
      }
    }
    let sheight = initHeight;
    let dom = inputArr;
    if (customized) {
      dom = (
        <div className="cursor-pointer" onClick={this.onCustomClick}>
          {this.props.children}
        </div>
      );
    }
    let rightActive = false;
    if (leftListSelectedKeys && leftListSelectedKeys.length > 0) {
      rightActive = true;
    }
    return (
      <div>
        {dom}
        {this.props.extraElement}
        <input
          type="hidden"
          id={fieldName}
          name={fieldName}
          value={hiddenIds}
        />
        <Modal
          wrapClassName="wea-hr-muti-input wea-browser-muli wea-browser-modal"
          title={titleEle}
          zIndex={this.props.zIndex}
          width={modalStyle.width}
          maskClosable={false}
          visible={visible}
          onCancel={this.handleCancel.bind(this)}
          footer={footer}
          {...this.props.browserModalProps}
        >
          <Spin spinning={loading}>
            <div style={{ padding: 10 }}>
              <div className="wea-hr-muti-input-left">
                <Row style={{ height: "35px" }}>
                  <Col span="24">
                    <WeaInputSearch
                      placeholder={""}
                      value={inputValue}
                      onSearchChange={v => {
                        this.setState({ inputValue: v });
                      }}
                      onSearch={this.onSearchChange.bind(this)}
                    />
                  </Col>
                </Row>
                <div>
                  <WeaNewScroll height={sheight} ref="weaSrcoll">
                    <WeaBrowserMutiLeft
                      contentType={contentType}
                      inputId={inputId}
                      inputName={inputName}
                      inputTop={inputTop}
                      inputBottom={inputBottom}
                      onDoubleClick={this.onleftDoubleClick.bind(this)}
                      onClick={this.onLeftListCheck.bind(this)}
                      selectedKeys={leftListSelectedKeys}
                      filterData={rightDatas}
                      datas={listDatas.filter(e => {
                        if (!e.isDevModule) {
                          if (expandModules.indexOf(e.parent) === -1) {
                            return false;
                          }
                        }
                        return true;
                      })}
                    />
                  </WeaNewScroll>
                </div>
              </div>
              <div className="wea-transfer-opration">
                <Operation
                  rightActive={rightActive}
                  leftActive={rightCheckedKeys && rightCheckedKeys.length > 0}
                  leftAllActive={leftAllActive}
                  rightAllActive={rightDatas && rightDatas.length > 0}
                  moveToRight={this.moveToRight}
                  moveToLeft={this.moveToLeft}
                  // moveAllToRight={this.moveAllToRight}
                  moveAllToLeft={this.moveAllToLeft}
                />
              </div>
              <div className="wea-hr-muti-input-right">
                <WeaBrowserMutiRight
                  ref="browserRight"
                  contentType={contentType}
                  inputId={inputId}
                  inputName={inputName}
                  inputTop={inputTop}
                  inputBottom={inputBottom}
                  data={rightDatas}
                  checkedCb={this.onRightCheck.bind(this)}
                  onDoubleClick={this.onRightDoubleClick.bind(this)}
                  checkedKeys={rightCheckedKeys}
                  height={initHeight}
                  onDrag={data => {
                    this.setState({ rightDatas: data });
                  }}
                />
              </div>
            </div>
          </Spin>
        </Modal>
      </div>
    );
  }
  onLeftListCheck(keys, datas, data) {
    if (data.isDevModule) {
      const { listDatas, loadedModules, expandModules } = this.state;
      if (loadedModules.indexOf(data.id) !== -1) {
        let modules = xor(expandModules, [data.id]);
        this.setState({ expandModules: modules });
      } else {
        const tableStr = "└";
        const index = findIndex(listDatas, ["id", data.id]);
        window.eventRegister &&
          window.eventRegister.register(data.id, {
            lib: data.obj.url.split(","),
            libName: data.name,
            fn() {
              return "success";
            }
          });
        window.eventRegister &&
          window.eventRegister.loadModule(
            data.id,
            () => {
              try {
                let coms = window[data.name].com;
                let comsData = [];
                let titleMap = window[data.name].titles || [];

                for (const key in coms) {
                  if (coms.hasOwnProperty(key)) {
                    const element = coms[key];
                    comsData.push({
                      id: `${listDatas[index].id}-${key}`,
                      idspan: `${listDatas[index].id}-${key}`,
                      name: `${key}`,
                      namespan: `<span style="margin-left:15px;">${key}</span>`,
                      title: `${titleMap[key] || key}`,
                      titlespan: `<div style="position:absolute;top:10px;left:0;">${tableStr} </div><span style="margin-left:15px;">${titleMap[
                        key
                      ] || key}</span>`,
                      parent: data.id,
                      parentName: data.name,
                      obj: element
                    });
                  }
                }
                var tempList = [...listDatas];
                tempList.splice(index + 1, 0, ...comsData);
                this.setState({
                  listDatas: tempList,
                  loadedModules: [...loadedModules, data.id],
                  expandModules: [...expandModules, data.id]
                });
              } catch (error) {
                alert("加载模块文件失败");
              }
            },
            () => {
              alert("加载模块文件失败");
            }
          );
        return;
      }
    }
    const { leftListSelectedData, inputId } = this.state;
    let targets = leftListSelectedData.concat(datas);
    targets = uniqBy(targets, inputId || "id");
    targets = targets.filter(t => keys.indexOf(t[inputId || "id"]) > -1);
    this.setState({
      leftListSelectedKeys: keys,
      leftListSelectedData: targets
    });
  }

  onRightCheck(keys) {
    this.setState({ rightCheckedKeys: keys });
  }
  throwCurrentState(ids, datas = []) {
    const { inputName, inputId } = this.state;
    ids = uniq(ids.split(",")).join(",");
    this.setState({ hiddenIds: ids });
    let names = [];
    datas = uniqBy(datas, inputId || "id");
    datas.forEach(d => {
      names.push(d[inputName + "span"] || d[inputName] || d.name);
    });
    names = uniq(names);

    this.props.onChange && this.props.onChange(ids, names.join(","), datas);
  }

  getSearchs() {
    const { browserConditions } = this.state;
    let items = [];
    !isEmpty(browserConditions) &&
      browserConditions.forEach(field => {
        items.push({
          com: (
            <WeaFormItem
              label={`${field.label}`}
              labelCol={{ span: `${field.labelcol}` }}
              wrapperCol={{ span: `${field.fieldcol}` }}
            >
              {WeaTools.getComponent(
                field.conditionType,
                field.browserConditionParam,
                field.domkey,
                this.props,
                field
              )}
            </WeaFormItem>
          ),
          colSpan: 1,
          hide: WeaTools.isComponentHide(field)
        });
      });
    return <WeaSearchBrowserBox items={items} />;
  }
}

let conditionParamsBK = {};
Main = Form.create({
  onFieldsChange(props, fields) {
    for (let key in fields) {
      conditionParamsBK[fields[key].name] = fields[key].value;
    }
  }
})(Main);
export default Main;



// WEBPACK FOOTER //
// ./ecology9/base/wea-dev-modules/index.js